define('components/photoset/complexNumber', [], function () {
    function Model(rel, abs) {
        this.rel = rel || 0;
        this.abs = abs || 0;
    }

    Model.prototype.getModule = function () {
        return Math.sqrt(Math.pow(this.rel, 2) + Math.pow(this.abs, 2));
    };

    Model.prototype.add = function (rel, abs) {
        rel = rel || 0;
        abs = abs || 0;

        if (rel instanceof Model) {
            var other = rel;

            rel = other.rel;
            abs = other.abs;
        }

        return new Model(this.rel + rel, this.abs + abs);
    };

    Model.prototype.multiply = function (rel, abs) {
        rel = rel || 0;
        abs = abs || 0;

        if (rel instanceof Model) {
            var other = rel;

            rel = other.rel;
            abs = other.abs;
        }

        return new Model(this.rel * rel - this.abs * abs, this.rel * abs + this.abs * rel);
    };

    Model.prototype.divide = function (rel, abs) {
        rel = rel || 0;
        abs = abs || 0;

        if (rel instanceof Model) {
            var other = rel;

            rel = other.rel;
            abs = other.abs;
        }

        var denominator = rel * rel + abs * abs;

        return new Model((this.rel * rel + this.abs * abs) / denominator, (rel * this.abs - abs * this.rel) / denominator);
    };

    return Model;
});